import { render, staticRenderFns } from "./ShowError.vue?vue&type=template&id=58354cb6"
import script from "./ShowError.vue?vue&type=script&lang=js"
export * from "./ShowError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports